import { render, staticRenderFns } from "./WaveSelector.vue?vue&type=template&id=7796b967&scoped=true"
import script from "./WaveSelector.vue?vue&type=script&lang=js"
export * from "./WaveSelector.vue?vue&type=script&lang=js"
import style0 from "./WaveSelector.vue?vue&type=style&index=0&id=7796b967&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7796b967",
  null
  
)

export default component.exports